// extracted by mini-css-extract-plugin
export var footer = "_ry-0";
export var inherit = "_ry-1";
export var input = "_ry-2";
export var modalContent = "_ry-3";
export var quillEditor = "_ry-4";
export var subtitle = "_ry-5";